module.exports = __webpack_public_path__ + "img/PPT版1.d2e60a3d.png";